import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function Analytics(props) {
  const { listen } = useHistory();
  const userInfo = props.userInfo;

  useEffect(() => {
    if (userInfo.id) {
      window.gtag("config", "G-H9GVYN9P93", {
        user_id: userInfo.id,
      });
    }
  }, [userInfo]);

  useEffect(() => {
    const unlisten = listen((location) => {
      if (!window.gtag) return;
      window.gtag("config", "G-H9GVYN9P93", {
        page_path: location.pathname + location.search,
      });
    });

    return unlisten;
  }, [listen]);

  return null;
}
